import type { GetUserProfileResponse } from '@gat-ship/types'
import { useUserApiCalls } from '@gat-ship/lib/http-client'
import { computed, ref } from 'vue'
import {
  ApiResponseError,
  AppError,
  ErrorCategory,
  ErrorCode
} from '../../error-handling'

export function useUserProfileDataSource() {
  const userProfile = ref<GetUserProfileResponse>()
  const { getUserProfileRequest } = useUserApiCalls()
  const userProfileGetter = computed(() => userProfile.value)

  function setUserProfile(user: GetUserProfileResponse) {
    userProfile.value = user
  }

  const userId = computed(() => userProfile.value!.userId)

  const isTenantAdmin = computed(
    () => userProfile.value?.isTenantAdmin ?? false
  )

  const isSupportUser = computed(() => {
    if (!userProfile.value) {
      return false
    }
    return (
      (userProfile.value.email.endsWith('@gatship.com') &&
        userProfile.value.homeTenantName.toLowerCase().includes('gat-ship')) ||
      userProfile.value.actor !== undefined
    )
  })

  async function fetchUserProfile() {
    // const userIsAuthenticated = await isAuthenticated()
    // if (!userIsAuthenticated) {
    //   throw new Error('User authentication failed')
    // }
    try {
      const result = await getUserProfileRequest()
      if (result) {
        setUserProfile(result)
      }
      return result
    } catch (err) {
      if (err instanceof ApiResponseError) {
        if (err.apiError.status === 401) {
          throw new AppError({
            category: ErrorCategory.AUTH,
            code: ErrorCode.USER_NOT_AUTHENTICATED,
            message: 'Authorization failed. Please login again.',
            details: { ...err }
          })
        }
      }
      throw err
    }
  }

  return {
    profile: userProfileGetter,
    fetchUserProfile,
    id: userId,
    isTenantAdmin,
    isSupportUser
  }
}
